const LOGO_SRC = '/logo.png';

export function BrandMark({
  className = '',
  size = 'md',
}: {
  className?: string;
  size?: 'sm' | 'md';
}) {
  return (
    <img
      src={LOGO_SRC}
      alt=""
      className={`${size === 'sm' ? 'h-7' : 'h-8 sm:h-9'} w-auto object-contain ${className}`}
    />
  );
}

export function BrandLoader({ size = 'md' }: { size?: 'xs' | 'sm' | 'md' }) {
  const sizeClass = size === 'xs' ? 'brand-loader--xs' : size === 'sm' ? 'brand-loader--sm' : '';
  return (
    <div className={`brand-loader ${sizeClass}`} aria-hidden>
      <span className="brand-loader__glow" />
      <span className="brand-loader__orbit" />
      <img src={LOGO_SRC} alt="" className="brand-loader__mark" />
    </div>
  );
}
